import React from 'react';
import { Box, Flex, Table, Heading, Text } from '@radix-ui/themes';
import NoData from 'components/common/noData';
import { selectUserSelectedLocal, selectUserSelectedLocalCode, selectDevice } from 'store/slices/common';
import { useSelector } from 'react-redux';
import { mapLongdescList } from 'app/constants';

const OrganizationChart = ({ localData }) => {
  const userSelectedLocalCode = useSelector(selectUserSelectedLocalCode);
  const userSelectedLocal = useSelector(selectUserSelectedLocal);
  const deviceType = useSelector(selectDevice);
  const isMobile = deviceType === 'mobile';

  return (
    <>
      <Box mt={isMobile ? 'var(--space-6)' : 'var(--space-12)'} className="organization-img-box">
        <Flex justify="center" className="section-inner">
          <div className="image-wrap organization">
            <img
              src={localData?.diagramUrl}
              alt={`${userSelectedLocal} 센터 조직도`}
              longdesc={`${mapLongdescList[userSelectedLocalCode]}`}
            />
          </div>
        </Flex>
      </Box>

      {localData?.details ? (
        localData.details?.map((item, index) => (
          <Box pt={isMobile ? 'var(--space-6)' : 'var(--space-15)'} className="table-wrap" key={index}>
            <Box mb={isMobile ? 'var(--space-4)' : 'var(--space-6)'}>
              <Text as="p" className={isMobile ? 'sub-title' : 'title4'}>
                {item.orgName}
              </Text>
              <Text as="p" className={isMobile ? 'body2 font-bold' : 'sub-title'}>
                {item.orgInfo}
              </Text>
            </Box>
            <Table.Root layout={'auto'} className="data-table">
              <caption>{`${userSelectedLocal} ${item.orgInfo} 테이블`}</caption>
              <Table.Header>
                <Table.Row>
                  <Table.ColumnHeaderCell
                    justify="center"
                    width={!isMobile && 'var(--space-25)'}
                    className={isMobile ? 'body3 font-bold' : 'sub-title'}
                  >
                    직책
                  </Table.ColumnHeaderCell>
                  <Table.ColumnHeaderCell
                    justify="center"
                    width={!isMobile && 'var(--space-30)'}
                    className={isMobile ? 'body3 font-bold' : 'sub-title'}
                  >
                    이름
                  </Table.ColumnHeaderCell>
                  <Table.ColumnHeaderCell
                    justify="center"
                    width={!isMobile && '200px'}
                    className={isMobile ? 'body3 font-bold' : 'sub-title'}
                  >
                    전화번호
                  </Table.ColumnHeaderCell>
                  {/*<Table.ColumnHeaderCell*/}
                  {/*  justify="center"*/}
                  {/*  py="var(--space-5)"*/}
                  {/*  className={isMobile ? "body3 font-bold" : "sub-title"}*/}
                  {/*  width="200px"*/}
                  {/*>*/}
                  {/*  이메일*/}
                  {/*</Table.ColumnHeaderCell>*/}
                  <Table.ColumnHeaderCell justify="center" className={isMobile ? 'body3 font-bold' : 'sub-title'}>
                    업무내용
                  </Table.ColumnHeaderCell>
                </Table.Row>
              </Table.Header>
              <Table.Body>
                {item.managers?.map((manager, index) => (
                  <Table.Row key={index}>
                    <Table.Cell justify="center" className={`body${isMobile ? '3' : '1'}`}>
                      {manager.rank || '-'}
                    </Table.Cell>
                    <Table.Cell justify="center" className={`body${isMobile ? '3' : '1'}`}>
                      {manager.name || '-'}
                    </Table.Cell>
                    <Table.Cell justify="center" className={`body${isMobile ? '3' : '1'}`}>
                      {manager.phone || '-'}
                    </Table.Cell>
                    {/*<Table.Cell justify="center" className={`body${isMobile ? '3' : '1'}`}>*/}
                    {/*  {manager.email}*/}
                    {/*</Table.Cell>*/}
                    <Table.Cell justify="center" className={`body${isMobile ? '3' : '1'}`}>
                      {manager.duty}
                    </Table.Cell>
                  </Table.Row>
                ))}
              </Table.Body>
            </Table.Root>
          </Box>
        ))
      ) : (
        <NoData />
      )}
    </>
  );
};

export default OrganizationChart;
